import axios from 'axios';

const URL_BASE = '/api_publica/v1/servicios/servicios';

export default {
  servicios(params, options = {}) {
    const opts = options || {};
    const defaultParams = {
      activos: true,
    };
    opts.params = Object.assign(defaultParams, params);

    return axios.get(URL_BASE, opts);
  },
};
